import * as React from 'react'

export const useResponsive = <T,>(sp: T, pc: T) => {
  const isBrowser = () => typeof window !== 'undefined'

  const [width, setWidth] = React.useState(isBrowser() ? window.innerWidth : 0)
  const [value, setValue] = React.useState<T>(pc)

  React.useEffect(() => {
    if (isBrowser()) {
      const handleWindowResize = () => setWidth(window.innerWidth)
      window.addEventListener('resize', handleWindowResize)
      return () => window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  React.useEffect(() => {
    setValue(width < 768 ? sp : pc)
  }, [width])

  return value
}
